import { PropertyType } from '@tallo/property';

export function isApartmentNumberRequired(propertyType: PropertyType | null | undefined) {
  return [PropertyType.APARTMENT, PropertyType.CONDO].includes(propertyType as PropertyType);
}
